export const offerIncludes: string[] = [
  '7 Complete Volumes of visual art instruction',
  '150 Ready-to-Teach Lessons organized by artistic focus',
  '100+ Visual Demonstrations',
  '30+ Ready-to-Teach Art Projects',
  'Visual Art Classroom Atlas',
  '100 No-Prep & Emergency Art Lessons',
  '365 Art Warm-Ups & Creative Starters',
  'Art Assessment, Rubrics & Student Portfolio Toolkit',
  'Art Classroom Management & Materials Toolkit',
  '50 Collaborative Art Projects & School Display Ideas',
  'Beginner to Advanced adaptations',
  'Printable resources',
  '7-Day Money-Back Guarantee',
  'Instant Access to all materials',
]

export const everythingIncluded: string[] = [
  'Volume 1: Visual Art Foundations & Creative Language',
  'Volume 2: Drawing Foundations & Visual Observation',
  'Volume 3: Painting, Color & Water-Based Media',
  'Volume 4: Composition, Design & Visual Communication',
  'Volume 5: Figure, Portrait, Nature & Subject Studies',
  'Volume 6: Mixed Media, Collage, Printmaking, Sculpture & Creative Art Practice',
  'Volume 7: Visual Art Classroom Atlas',
  '150 Ready-to-Teach Art Lessons',
  '100+ Visual Demonstrations',
  '30+ Ready-to-Teach Art Projects',
  'Bonus 1: 100 No-Prep & Emergency Art Lessons',
  'Bonus 2: 365 Art Warm-Ups & Creative Starters',
  'Bonus 3: Art Assessment, Rubrics & Student Portfolio Toolkit',
  'Bonus 4: Art Classroom Management & Materials Toolkit',
  'Bonus 5: 50 Collaborative Art Projects & School Display Ideas',
  '7-Day Money-Back Guarantee',
  'Instant Digital Access',
]

export const painCosts: string[] = [
  'Hours lost searching for activities that work together and flow naturally',
  'Classes that feel repetitive because you keep returning to the same projects',
  'Visible improvisation that\u2019s quietly undermining your confidence as a teacher',
  'Not enough variety in techniques, materials and creative focus week to week',
  'Weekends spent planning instead of resting, recovering, or living your life',
  'Mixed-level classes that feel chaotic because you don\u2019t have organized alternatives',
  'No clear way to assess artistic progress without grading personal taste',
  'Last-minute scrambling when a project finishes early or a lesson doesn\u2019t work as expected',
]

export const noMore: string[] = [
  'No more Sunday nights searching for activities that flow',
  'No more rushed or improvised classes',
  'No more repeating the same projects',
  'No more lost weekends on planning instead of living',
  'No more entering class wishing you\u2019d prepared more',
  'No more chaos with mixed-level groups',
  'No more guessing how to assess creative progress',
]
